import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutSidebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutSidebar"><Path d="M20.5 3.5H21V3H20.5V3.5ZM20.5 20.5V21H21V20.5H20.5ZM3.5 20.5H3V21H3.5V20.5ZM3.5 3.5V3H3V3.5H3.5ZM20 3.5V20.5H21V3.5H20ZM20.5 20H3.5V21H20.5V20ZM4 20.5V3.5H3V20.5H4ZM3.5 4H20.5V3H3.5V4Z" fill="currentColor"/><Path d="M20.5 12.5H21V11.5H20.5V12.5ZM9.5 11.5H9V12.5H9.5V11.5ZM20.5 11.5H9.5V12.5H20.5V11.5Z" fill="currentColor"/><Path d="M10 3.5V3H9V3.5H10ZM9 20.5V21H10V20.5H9ZM10 12V3.5H9V12H10ZM9 12V20.5H10V12H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutSidebar;
